import { Component } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { UploadConfirmationComponent } from '../upload-confirmation/upload-confirmation.component';
import { DocumentCaptureBase } from '../document-capture-base.component';

@Component({
    selector: 'app-tpp-ejourney',
    templateUrl: './tpp-ejourney.component.html',
    styleUrl: './tpp-ejourney.component.scss',
    imports: [ReactiveFormsModule, UploadConfirmationComponent]
})
export class TppEjourneyComponent extends DocumentCaptureBase {
  instructions: string[] = [
    'The account holder will need to confirm their bank account via the app and upload Proof of Address and Proof of ID.',
    'The policy holder will need to complete the full application journey.'
  ];

  constructor(private fb: FormBuilder) { 
    super();
  }

  tppForm = this.fb.group({
    tppCompleted: [false],
  });

  onChange() {
    let value = this.tppForm.controls.tppCompleted.value ?? false;
    this.document.value = null;
    this.document.keyValues = [
      {
        key: 'tpp',
        value: value.toString()
      }
    ];
    this.document.enableSubmitButton = value;
    this.onChanged.emit(this.document);
  }
}
